module.exports = __webpack_public_path__ + "img/qr.28d94b7f.png";